module.exports = __webpack_public_path__ + "img/IMG_9405.128354df.jpg";